/* eslint-disable no-unused-vars*/
import {Component} from "react";
import React from "react";
import styled from 'styled-components/macro';
import Prism from 'prismjs';

import prismBash from 'prismjs/components/prism-bash.min';
import prismJava from 'prismjs/components/prism-java.min';
import prismJson from 'prismjs/components/prism-json.min';
import prismDocker from 'prismjs/components/prism-docker.min';
import prismNumbers from 'prismjs/plugins/line-numbers/prism-line-numbers.min';
import prismNumbersCss from 'prismjs/plugins/line-numbers/prism-line-numbers.css';
import normalizeWhitespace from 'prismjs/plugins/normalize-whitespace/prism-normalize-whitespace.min';
import css from 'prismjs/themes/prism-coy.css';

import PropTypes from "prop-types";
import breakpoint from "styled-components-breakpoint";

const CodeWrapper = styled.div.attrs(props => ({
    className: props.className
}))`
font-family: ${props => props.theme.codeTextFamily} !important;
`;


const StyledPre = styled.pre.attrs(props => ({
    className: (props.numbered ? "line-numbers" : ""),
}))`
    
`;

const StyledCodeSection = styled.code.attrs(props => ({
    className: props.className
}))`
    font-size: 0.65em!important;
    > span[class*="line-numbers"] {
        width: 2em;
    };
    padding-left: 2.8em!important;
    
    ${breakpoint('md')`
        font-size: 1rem!important;
        padding-left: 3.8em!important;
        > span[class*="line-numbers"] {
            width: 2.5em!important;
        };
    `};
    max-height: 30em;
`;

class Code extends Component {
    constructor(props) {
        super(props);
        this.codeBlock = null
    }

    componentDidMount() {
       Prism.highlightElement(this.codeBlock, false);
    }

    setCodeBlockDomElement = domElement => {
        this.codeBlock = domElement;
    };

    render() {
        if(!this.props.language) {
            return (<code className="language-markup" ref={this.setCodeBlockDomElement}>{this.props.children}</code>);
         }else {
            const languageName = "language-" + this.props.language;
            return (
                <CodeWrapper className={this.props.className}>
                    <StyledPre numbered={this.props.numbered}>
                        <StyledCodeSection className={languageName} ref={this.setCodeBlockDomElement}>
                            {this.props.children}
                        </StyledCodeSection>
                    </StyledPre>
                </CodeWrapper>
            )

        }
    }
}


Code.defaultProps = {
    numbered: true,
};

Code.propTypes = {
    numbered: PropTypes.bool,
    language: PropTypes.oneOf(["java", "javascript", "bash", "json", "xml", "docker", "markup", "text"])
};

export default Code;
export {StyledCodeSection};
